import React from 'react';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-brand-dark/40 backdrop-blur-sm" data-id="element-163">
      <div className="relative w-full max-w-2xl max-h-[90vh] overflow-auto bg-brand-cream rounded-2xl shadow-2xl" data-id="element-164">
        <div className="sticky top-0 bg-brand-cream border-b border-brand-sage p-5 flex justify-between items-center" data-id="element-165">
          <h2 className="text-xl font-serif font-bold text-brand-dark" data-id="element-166">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-brand-sage/50 transition-colors" aria-label="Fechar" data-id="element-167">
            <XIcon className="h-5 w-5 text-brand-text" data-id="element-168" />
          </button>
        </div>
        <div className="p-6 md:p-8 text-brand-text/80 text-sm md:text-base leading-relaxed" data-id="element-169">
          {content}
        </div>
      </div>
    </div>;
}